(function() {

  // ── PREVENT iOS INPUT ZOOM ──
  var viewportMeta = document.querySelector('meta[name="viewport"]');
  if (viewportMeta) {
    viewportMeta.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
  }

  // ── TICKER ──
  var tickerItems = ['5g Creatine Monohydrate','1000mg Sodium','200mg Potassium','60mg Magnesium','Zero Sugar','No Fillers','Third Party Tested','Made in USA','30 Stick Packs','One Daily Ritual'];
  var track = document.getElementById('credoTickerTrack');
  if (track) {
    var doubled = tickerItems.concat(tickerItems).concat(tickerItems).concat(tickerItems);
    track.innerHTML = doubled.map(function(t) {
      return '<div class="credo-ticker-item"><span>' + t + '</span><div class="credo-ticker-dot"></div></div>';
    }).join('');
  }

  var credoSelectedPrice = 'not specified';
  var credoCount = 247;

  // ── KLAVIYO CONFIG ──
  var KLAVIYO_API_KEY = 'WpCQG5';
  var KLAVIYO_LIST_ID = 'WsXkSf';

  // ── KLAVIYO SUBSCRIBE ──
  function credoSubscribeToKlaviyo(firstName, email, pricePreference, position, onSuccess, onError) {
    var params = new URLSearchParams();
    params.append('g',           KLAVIYO_LIST_ID);
    params.append('email',       email);
    params.append('$first_name', firstName);
    params.append('$fields',     '$first_name,waitlist_price_preference,waitlist_position,waitlist_source');
    params.append('waitlist_price_preference', pricePreference);
    params.append('waitlist_position',         String(position));
    params.append('waitlist_source',           'website');

    fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
      method:  'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body:    params.toString()
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      console.log('Klaviyo response:', data);
      onSuccess();
    })
    .catch(function(err) {
      console.error('Klaviyo error:', err);
      onSuccess();
    });
  }

  // ── SHOW SUCCESS STATE ──
  function credoShowSuccess(formState, successState) {
    if (typeof fbq !== 'undefined') {
      fbq('track', 'Lead', {
        content_name: 'Credo Waitlist Signup',
        currency: 'USD',
        value: 45.00
      });
      fbq('trackCustom', 'WaitlistSignup');
    }
    formState.style.transition = 'opacity .28s ease, transform .28s ease';
    formState.style.opacity = '0';
    formState.style.transform = 'translateY(-10px)';
    setTimeout(function() {
      formState.style.display = 'none';
      successState.style.display = 'flex';
      successState.style.opacity = '0';
      successState.style.transition = 'opacity .38s ease';
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          successState.style.opacity = '1';
        });
      });
    }, 300);
  }

  // ── FORM SUBMIT ──
  window.credoHandleSubmit = function(e) {
    e.preventDefault();

    var firstName = document.getElementById('credoFirstName').value.trim();
    var email     = document.getElementById('credoEmail').value.trim();
    if (!firstName || !email) return;

    var submitBtn = document.getElementById('credoSubmitBtn');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Joining...';
    }

    var formState    = document.getElementById('credoFormState');
    var successState = document.getElementById('credoSuccessState');

    credoSubscribeToKlaviyo(
      firstName,
      email,
      credoSelectedPrice,
      credoCount,
      function() { credoShowSuccess(formState, successState); },
      function() { credoShowSuccess(formState, successState); }
    );
  };

  // ── BOTTOM SUBMIT ──
  window.credoHandleBottomSubmit = function() {
    var emailEl = document.getElementById('credoBottomEmail');
    if (!emailEl || !emailEl.value.trim()) return;

    var email = emailEl.value.trim();
    var btn   = document.querySelector('.credo-bcta-btn');

    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Joining...';
    }

    credoSubscribeToKlaviyo(
      '',
      email,
      'not specified',
      credoCount,
      function() {
        if (typeof fbq !== 'undefined') {
          fbq('track', 'Lead', {
            content_name: 'Credo Waitlist Signup',
            currency: 'USD',
            value: 45.00
          });
          fbq('trackCustom', 'WaitlistSignup');
        }
        if (btn) {
          btn.textContent = "✓  You're on the list";
          btn.style.background = 'var(--forest3)';
          btn.style.color = 'white';
          emailEl.value = '';
          setTimeout(function() {
            btn.disabled = false;
            btn.textContent = 'Join the Waitlist →';
            btn.style.background = '';
            btn.style.color = '';
          }, 3000);
        }
      },
      function() {
        if (btn) {
          btn.disabled = false;
          btn.textContent = 'Join the Waitlist →';
        }
      }
    );
  };

  // ── SCROLL REVEAL ──
  var revealEls = document.querySelectorAll('.credo-reveal');
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    revealEls.forEach(function(el) { obs.observe(el); });
  } else {
    revealEls.forEach(function(el) { el.classList.add('visible'); });
  }

})();